import { FC } from 'react'
import cn from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import Link from 'components/ui/Link'
import { sendEvent } from '@lib/tracking'

interface Props {
  className?: string
}

interface FooterLink {
  href: string
  label: string
  id: string
}

export const CheckoutFooter: FC<Props> = ({ className }) => {
  const { t } = useTranslation()

  const footerLinks: FooterLink[] = [
    {
      href: '/faq',
      label: t('footer:checkout_faq_link'),
      id: 'checkout_footer_faq',
    },
    {
      href: '/privacy',
      label: t('footer:privacy_link'),
      id: 'checkout_footer_privacy',
    },
    {
      href: '/terms',
      label: t('footer:checkout_terms_link'),
      id: 'checkout_footer_faq',
    },
  ]

  const handleLinkClick = (link: {
    href: string
    label: string
    id: string
  }) => {
    sendEvent({
      event: 'Click_Footer',
      data: {
        button_id: link.id,
        click_text: link.label,
        click_url: link.href,
        page_path: window.location.pathname,
      },
    })
  }

  return (
    <footer className={cn('border-darkPurple border-t py-4', className)}>
      <div className="mx-content-margin-mobile sm:mx-content-margin-desktop flex flex-col sm:flex-row justify-between items-center ">
        {footerLinks.map((link: FooterLink, index: number) => (
          <Link
            href={link.href}
            key={index}
            aria-label={link.label}
            onClick={() => handleLinkClick(link)}
            className={cn('uppercase my-4', {
              'mr-2': index < footerLinks.length - 1,
              'ml-2': index > 0,
            })}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </footer>
  )
}
